<template>
    <div class="javacode">
        <pre class="quelltext">
<code>{{java}}</code>
        </pre>
    </div>
</template>

<script>
    export default {
        name: 'javacode',
        props: ['klasse'],
        computed: {
            java() {
                let code = 'class ' + this.klasse.name + '\n{\n';
                for (let attribut of this.javaAttribute) {
                    code += '   ' + attribut + '\n'
                }
                code += '\n'
                for (let methode of this.javaMethoden) {
                    code += '   ' + methode + '\n'
                }
                code += '}'
                return code
            },
            javaAttribute() {
                let attribute = [];
                for (let attribut of this.klasse.fields) {
                    if (attribut.name)
                        attribute.push(attribut.type ? (attribut.type + ' ' + attribut.name + ';') : ('... ' + attribut.name + '; // Datentyp fehlt'))
                }
                return attribute;
            },
            javaMethoden() {
                let methoden = [];
                for (let methode of this.klasse.methods) {
                    if (methode.name != '') {
                        let istKonstruktor = methode.name == this.klasse.name;
                        let methodenCode = '';
                        if (!istKonstruktor)
                            methodenCode += methode.returnType ? methode.returnType + ' ' : '// Rückgabetyp fehlt\n   ...';
                        methodenCode += methode.name + '(';
                        let params = '';
                        for (let p of methode.parameters) {
                            params += p.type + ' ' + p.name + ', ';
                        }
                        // letztes Komma und Leerzeichen abschneiden
                        if (params.length > 0)
                            params = params.substr(0, params.length - 2);
                        methodenCode += params + ') {\n      // Implementierung';
                        if (methode.returnType != 'void' && !istKonstruktor) {
                            if (methode.returnType === 'int') methodenCode += '\n      return 42; // nur ein Beispiel';
                            else if (methode.returnType === 'double') methodenCode += '\n      return 3.1415; // nur ein Beispiel';
                            else if (methode.returnType === 'String') methodenCode += '\n      return "Hallo"; // nur ein Beispiel';
                            else if (methode.returnType === 'boolean') methodenCode += '\n      return true; // nur ein Beispiel';
                            else methodenCode += '\n      return ... ; // Rückgabe des Ergebnisses';
                        }
                        methodenCode += '\n   }'

                        methodenCode += '\n';
                        methoden.push(methodenCode);
                    }
                }
                return methoden;
            }
        }
    }
</script>

<style scoped>
    pre.quelltext {
        margin-top: 0px !important;
    }
</style>



// WEBPACK FOOTER //
// JavaCode.vue?309561f6